import SPAHeadUpdater from "@resources/SPAHeadUpdater/SPAHeadUpdater";

class FetchModalBasedOnAnchorClass {
	constructor() {
		document.addEventListener("click", this.handleOpenClick.bind(this));
		document.addEventListener("click", this.handleClose.bind(this));
		window.addEventListener('DOMContentLoaded', () => {
			window.addEventListener("popstate", this.handlePopState.bind(this));
		})
		this.actualPage = false;
		this.registeredFetchs = [];
		this.openModals = [];
	}

	registerFetch(param, name, modalId, modalAuxiliarClasses, responseSelector, closeButtonSelector, beforeOpenEvent = false, updateHead = true) {
		let isRegistered = this.registeredFetchs.length && this.registeredFetchs.filter(registered => registered.name === name).length
		if (isRegistered) {
			console.warn(`Fetch type ${name} already registered:`, isRegistered[0])
			return;
		}
		this.registeredFetchs.push({
			param: param,
			name: name,
			modalId: modalId,
			responseSelector: responseSelector,
			closeButtonSelector: closeButtonSelector,
			modalClassName: modalAuxiliarClasses,
			beforeOpenEvent: beforeOpenEvent,
			updateHead: updateHead,
		})
	}

	getFetchTarget(urlString) {
		if (!this.registeredFetchs.length) {
			return false;
		}
		const url = new URL(urlString);
		let fetchTarget = this.registeredFetchs.filter(registered => url.searchParams.get(registered.param) == registered.name);
		return fetchTarget.length && fetchTarget[0];
	}


	async handleOpenClick(e) {
		const target = e.target.closest("a");
		if (!target || !this.registeredFetchs.length) return;

		let fetchTarget = this.getFetchTarget(target.href);
		if (!fetchTarget) return;

		e.preventDefault();
		this.handleOpen(target.href, fetchTarget);
	}

	async handleOpen(url, fetchTarget, pushState = true) {
		try {
			const response = await fetch(url);
			const text = await response.text();
			const parser = new DOMParser();
			const page = parser.parseFromString(text, "text/html");
			const content = page.querySelector(fetchTarget.responseSelector);

			fetchTarget.updateHead && this.updateHead(page, true);
			this.openModal(content, fetchTarget);
			pushState && history.pushState({ modal: url }, "", this.cleanUrl(url,fetchTarget.param));

		} catch (error) {
			console.error("Error fetching content:", error);
		}
	}

	handleClose(e) {
		const target = this.registeredFetchs.filter(registered => e.target.closest(registered.closeButtonSelector))
		if (!target.length) return;
		e.preventDefault();
		history.back();
	}

	handlePopState(e) {
		const fetchTarget = e.state?.modal && this.getFetchTarget(e.state.modal)
		if (fetchTarget) {
			this.handleOpen(window.location.href, fetchTarget, false);
		} else {
			this.closeModal();
		}
	}

	openModal(htmlContent, fetchTarget ) {
		let modal = document.createElement("div");

		if (this.openModals.filter(m => m.el === modal).length) {
			return;
		}

		let addClassNames = fetchTarget.modalClassName.split(' ');

		document.documentElement.style.overflow = 'hidden';
		modal.id = fetchTarget.modalId;
		addClassNames.map(className => modal.classList.add(className));
		document.body.appendChild(modal);
		modal.innerHTML = htmlContent.innerHTML;

		const eParams = {
			modal: modal,
			htmlContent: htmlContent,
			fetchTarget: fetchTarget,
		}

		if (typeof fetchTarget.beforeOpenEvent === 'function') {
			htmlContent = fetchTarget.beforeOpenEvent(eParams)?.htmlContent || htmlContent;
		}

		this.openModals.push({el: modal, detail: eParams});

		modal.style.opacity = 0;
		setTimeout(() => {
			modal.style.opacity = null;
		}, 10);
	}

	closeModal() {
		let modal = this.openModals.length && this.openModals[this.openModals.length - 1]
		if (modal?.el) {
			document.documentElement.style.overflow = null;
			modal.el.remove(modal.el);
			delete this.openModals[this.openModal.length - 1];
			modal.detail?.fetchTarget?.updateHead && this.updateHead(false)
		}
	}

	async updateHead(parsedPage) {
		this.actualPage = parsedPage ? document.cloneNode(true) : this.actualPage;
		let SPA = new SPAHeadUpdater(parsedPage ? parsedPage : this.actualPage, false);
		await SPA.init();
		return true;
	}

	cleanUrl(url,parameter){
		url = new URL(url);
		url.searchParams.delete(parameter);
		return url.origin + url.pathname + (url.search ? '?' + url.searchParams.toString() : '');
	}


}

const FetchModalBasedOnAnchor = new FetchModalBasedOnAnchorClass();
export default FetchModalBasedOnAnchor;
